module.exports = {
  caseLabels: [],
  caseSearchStatusesDefault: [],
  showCaseDetailsInList: ['name', 'sex'],
  searchCaseDetailsInModal: ['name'],
  components: require('./components'),
  messages: require('./messages'),
  releaseNotes: require('./releaseNotes')
}
